<template>
    <section class="container flex justify-center">
        <div class="grid gap-30 grid-cols-12">
            <div class="hidden lg:block col-span-3"></div>
            <div class="col-span-12 lg:col-span-6">
                <lazy-image :image="data.image" :rounded="rounded"></lazy-image>
            </div>
            <div class="hidden lg:block col-span-3"></div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        },
        rounded: {
            type: Boolean,
            default: false
        }
    }
};
</script>
